<div class="root-body" style="padding: 0"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="card">
        <!-- Table -->
        <p-table #homeTransactionsGrid
                 [columns]="cols"
                 [value]="payoutTransactions"
                 [lazy]="true"
                 responsiveLayout="auto"
                 selectionMode="single"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [selection]="selectedTransaction"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [autoLayout]="true"
                 [loading]="loading"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-fleft">
                        <ol class="breadcrumb-body breadcrumbs-menu">
                            <ng-container *ngFor="let item of onboardingTabMenu">
                                <li class="breadcrumbs-menu-item"
                                    [class]="(item.value === menuHomeEnumActive) ? 'breadcrumbs-menu-active' : ''"
                                    (click)="clickChangeMenuHomeActive(item.value)">{{item.name}}</li>
                            </ng-container>
                        </ol>
                    </div>
                </div>
                <div class="onboarding-head">
                    <div class="onboarding-head-title">
                        {{getMenuHomeName()}}
                    </div>
                    <div class="ml-5 mt-2 mr-2">
                        <column-selector #columnSelector
                             [defaultColumns]="defaultCols"
                             (selectedColumnsChange)="onSelectedColumnsChange($event)"
                             [tableName]="getMenuHomeName()"
                             [(selectedColumns)]="cols">
                        </column-selector>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of this.cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                               (ngModelChange)="handleFilterChange(filter.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="filter.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.CalendarTime">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [timeOnly]="true"
                                            [showIcon]="true"
                                            hourFormat="12"
                                            placeholder="{{filter.placeholder}}"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction>
                <tr>
                    <td *ngFor="let col of cols" [pSelectableRow]="transaction" class="ui-resizable-column fixed-col">
                        <ng-container [ngSwitch]="col.field">
                            <ng-container *ngSwitchCase="'Id'">
                                <span class="underline-black-col">
                                    {{transaction.Id}}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'CreatedAt'">
                                {{transaction.CreatedAt | date:'short'}}
                            </ng-container>
                            <ng-container *ngSwitchCase="'Amount'">
                                {{transaction.Amount | currency:"PHP"}}
                            </ng-container>
                            {{getPaidAt(transaction) | date:'short'}}
                            <ng-container *ngSwitchCase="'Status'">
                                <span [ngStyle]="getStatusStyles(transaction.Status)">
                                    {{ getStatusName(transaction.Status) }}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{transaction[col.field]}}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="paginator.Items.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + paginator.Items.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<finance-payout-details *ngIf="showDetailTransactionSidebar"
                        [showTransactionsSidebar]="showDetailTransactionSidebar"
                        [onHide]="handleHideTransactionInfo"
                        (updateTransactionsEmit)="updateEventEmit($event)"
                        [_payoutTransaction]="selectedTransaction"></finance-payout-details>

<finance-payout-settings *ngIf="visibleTransactionsSettings"
                       [showTransactionsSidebar]="visibleTransactionsSettings"
                       (changedVisibleHomeTransactionsFilterEmit)="changedVisibleTransactionsSettingsEmit($event)"></finance-payout-settings>


<p-toast position="top-right"></p-toast>
